export default __webpack_public_path__ + "7e8c24e00f45ac8c3ea618c8154ba462.svg";